import React from 'react'
import { Tooltip, Table, Input, Button  } from 'antd';
import Icon from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import {vowl2Table, vowl2List} from '../../utils/emdUtil';
import EMDTableColumnName from './EMDTableColumnName';
import EMDTableColumnDetail from './EMDTableColumnDetail';
import EMDTableColumnAction from './EMDTableColumnAction';

// rowSelection objects indicates the need for row selection
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
//    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
//    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
//    console.log(selected, selectedRows, changeRows);
  },
};

const checkFilter = (value, dataIndex, record) => {
  //Если соответствует поисковой строке само название
//  if ((!record[dataIndex])||(record[dataIndex]==null)) return false;
  let inc = record[dataIndex].toString().toLowerCase().includes(value.toLowerCase());
  if (Array.isArray(record.children)){
    for (let index = 0; index < record.children.length; index++) {
      let element = record.children[index];
      console.log(element);
      if (checkFilter(value, dataIndex, element)) return true;
    }        
  } 
  return inc;
}

class EMDTable extends React.Component {

    constructor(props, context) {
      super(props, context)
      const {assets, loading} = props;
      this.state = {
        initLoading: false,
        loading, 			//Флаг загрузки
        data: assets,
        list: assets,
        searchText: ''    //Значение посиковой строки
      };

      this.onAction = this.onAction.bind(this);

      this.columns = [{
        title: 'Наименование', dataIndex: 'name', key: 'name',
        ...this.getColumnSearchProps('name'),
        render: (value, row, index) => <EMDTableColumnName value={value} row={row} index={index} onAction={this.onAction}/>
      }, {
        title: 'Состав', dataIndex: 'props', key: 'props',
        width: '40%',
        render: (value, row, index) => <EMDTableColumnDetail value={value} row={row} index={index} onAction={this.onAction}/>
      },{
        title: 'Действия', key: 'operation', fixed: 'right',
        width: 30,
        render: (record, text) => <EMDTableColumnAction row={record} onAction={this.onAction}/>
      }];      
    }
    
  componentDidMount() {
  }

  onAction (record, text, modalWidth=undefined) {
    //console.log("EMDTable.js onAction", record, text, modalWidth);
    const {onAction} = this.props;
    if (onAction) 
      onAction(record, text, modalWidth);
  }


  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Поиск
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Сброс
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => 
      checkFilter(value, dataIndex, record),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  render() {
    const { initLoading, loading, searchText } = this.state;
    const {content} = this.props;
    const data =(searchText=='')? vowl2Table(content, "http://hbz.ru/ontologies/emd"):vowl2List(content, "http://hbz.ru/ontologies/emd");
    //console.log(this); console.log(data);console.log(JSON.stringify(content));
    return (
        <Table columns={this.columns} rowSelection={rowSelection} dataSource={data} />
    );
  }
}
/** 
<span>
  {(row && Array.isArray(row.annotations)) && (
      <Tooltip title="Дополнительная информация по свойствам">
        <Button size="small" onClick={(e)=> {e.preventDefault(); this.onAction(row, "DETAIL")}}><Icon type="snippets" style={{ verticalAlign: "+0.125em"}}/></Button>
      </Tooltip>
      )}{value}
</span>

<span>
  {record.class && (
    <Tooltip title="UML диаграмма">
      <Button size="small" onClick={(e)=> {e.preventDefault(); this.onAction(record, "UML", calculateModalWidth(record))}}>UML</Button>
    </Tooltip>)}
  {'\u00A0'}        
  {record.class && (    
    <Tooltip title="XSD файл">
      <Button size="small" onClick={(e)=> {e.preventDefault(); this.onAction(record, "XSD")}}>XSD</Button>
    </Tooltip>)}
  {'\u00A0'}
  <Tooltip title="Информация об элементе полученная в ходе коллективной работы.">
    <Button size="small" onClick={(e)=> {e.preventDefault(); this.onAction(record, "CLM")}}>CLM</Button>
  </Tooltip>
</span>,
*/

export default EMDTable;